import { DrawerPresentationProps } from "@insite/mobius/Drawer";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const drawer: RecursivePartial<{
    defaultProps?: DrawerPresentationProps | undefined;
}> = {
    defaultProps: {
        cssOverrides: {
            drawerTitle: css`
                background: ${getColor(colorStrings.primaryMain)};
                color: ${getContrastColor(colorStrings.primaryMain)};
            `,
            titleButton: css`
                background: ${getColor(colorStrings.primaryMain)};
                border-color: ${getColor(colorStrings.primaryMain)};
                color: ${getContrastColor(colorStrings.commonGlobalWhite)};
                ${IconWrapper} {
                    color: ${getContrastColor(colorStrings.commonGlobalWhite)};
                }
            `,
        },
    },
};
